import React from "react";
import { Box } from '@mui/material';
import Hero from "../../../components/Hero";
import Features from "../../../components/features";
import MisApp from "../../../components/MisApp";
import MisVideos from "../../../components/MisVideos";
import MisDiseños from "../../../components/MisDiseños";
import MiMusica from "../../../components/MiMusica";
import MenuRedes from "../../../components/MenuRedes";

const MainPages = () => {
    return(
        <Box>
            <Hero />
            <Features />
            <MisApp />
            <MiMusica />
            <MisDiseños />
            <MisVideos />
            <MenuRedes />
        </Box>
    );
}

export default MainPages;